module.exports = "images/9ans.8a8a7b4f.png";